<template>
  <v-icon
    class="github-icon"
    v-text="'mdi-github'"
  />
</template>

<script>
export default {
  name: 'GitHubIcon',
};
</script>

<style lang="scss" scoped>

</style>
